module.exports = __webpack_public_path__ + "img/slide-16.e251dccf.jpg";